import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M20 10.78V20h-9.22L20 10.78m2-4.81L6 22h16V5.97z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 9.98L6 22h12V9.98zM3.93 5.93l1.29 1.29c3.19-3.19 8.38-3.19 11.57 0l1.29-1.29c-3.91-3.91-10.25-3.91-14.15 0zm5.14 5.14L11 13l1.93-1.93c-1.07-1.06-2.79-1.06-3.86 0zM6.5 8.5l1.29 1.29c1.77-1.77 4.65-1.77 6.43 0L15.5 8.5c-2.48-2.48-6.52-2.48-9 0z"
})), 'CellWifiOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CellWifiOutlined.js
// module id = 2719
// module chunks = 2